<template>
  <div class="shadow rounded-lg text-sm w-ful">
      <div
      class="p-4 bg-gray-200 border-b border-gray-400 flex flex-row justify-between place-items-center"
    >
      <div>
        <h1 class="font-bold">{{ task.farmer_name }}</h1>
        <div class="mt-2">
          {{ task.farmer_address }}
        </div>
      </div>

      <div>
        <inertia-link
          class="inline-flex justify-center py-2 px-4 btask btask-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          v-if="canEditTask"
          :href="route('app.task.edit', task.id)"
        >
          Edit
        </inertia-link>
      </div>
    </div>

    <div class="p-4 bg-white grid grid-cols-2 sm:grid-cols-3">
      <div class="p-2" v-if="$page.props.auth.user.role == 'admin'">
        <label class="block text-sm font-bold text-gray-700" for="advisor">
          Farms
        </label>

        {{ task.farms }}
      </div>

      <div class="p-2" v-if="$page.props.auth.user.role == 'admin'">
        <label class="block text-sm font-bold text-gray-700" for="advisor">
          Advisor
        </label>

        {{ task.advisor }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="soil_sampler">
          Soil Sampler
        </label>

        {{ task.soil_sampler }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="id_number">
          Task ID
        </label>

        {{ task.farmteam_task_number }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="date">
          Scheduled From
        </label>

        {{ task.date }}
      </div>
      <div class="p-2" v-if="task.complete_by">
        <label class="block text-sm font-bold text-gray-700" for="date">
          Scheduled To
        </label>

        {{ task.complete_by }}
      </div>
      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="status">
          Status
        </label>

        {{ task.status }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="status">
          Lab
        </label>

        {{ task.lab }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="status">
          Required Samples
        </label>

        {{ task.no_of_samples }}
      </div>

      <div class="p-2">
        <label class="block text-sm font-bold text-gray-700" for="status">
          Approved by
        </label>

        {{ task.issues_approve_by }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: Object,
  },
    computed: {
        canEditTask() {
            const user = this.$page.props.auth.user;
            const task = this.task;

            if (!user || !task) return false;

            if (user.role === 'admin') return true;

            if ((user.role === 'consultant' || user.role === 'consultant_user') &&
                user.organisation_id === task.organisation_id) {
                return true;
            }

            if (user.role === 'contractor' && user.id === task.assigned_to) {
                return true;
            }

            if (user.role === 'soil_sampler' && task.assigned_to === user.id) {
                return true;
            }

            return false;
        }
    }
};
</script>
